<span class="my-bets-print-title__text">{{ sitecore.myBets_Print.MyBetsPageTitle }}</span>
<div class="my-bets-print-title__horizontal-line"></div>
